import { openTrailer } from './Trailer.jsx'

const Navbar = () => {
    return (
        <nav id="nav">
            <div className="nav-in">
                <a href="#top" className="brand">VINEWOOD</a>
                <div className="nav-links">
                    <a className="link" href="#about">Despre</a>
                    <a className="link" href="#trailer" onClick={(e) => { e.preventDefault(); openTrailer() }}>Trailer</a>
                    <a className="link" href="#gallery">Gameplay</a>
                    <a className="btn btn-primary" href="https://vinewood.ro/invite" target="_blank" rel="noreferrer">Discord</a>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
